import { atom } from 'recoil';

export interface UIStateProps {
  hasError?: string | boolean;
  hasFatalError?: boolean;
  hasWarning?: { message: string; route: string } | null;
  isFetching?: boolean;
}
const uiResetErrorEffect = ({ setSelf, onSet }: any) => {
  onSet((newState: UIStateProps) => {
    if (newState.hasError) {
      setTimeout(() => {
        setSelf({ ...newState, hasError: false });
      }, 2000);
    }
  });
};
export const uiState = atom<UIStateProps>({
  key: 'uiState',
  effects: [uiResetErrorEffect],
  default: {},
});
